import DocumentUtils from './document_utils';

export default {
    wrapTextWithTag(template) {
        const notElTypeArr = ['a', 'span', 'strong', 'em', 'b', 'small'];
        const templateElements = $($.parseHTML(`<div>${template}</div>`));

        $.each(templateElements.find('*'), (i, el) => {
            const $el = $(el);
            const elType = $el.prop('nodeName').toLowerCase()
            const validElType = !notElTypeArr.includes(elType);

            // TODO: limit this to only text inside cells with no wrapper

            if (this.nodeHasText(el) && validElType) {
                var wrappedEl = $el.html().replace(`${el.childNodes[0].nodeValue}`, `<div class="text-container">${el.childNodes[0].nodeValue}</div>`);
                $el.html(wrappedEl);
            }
        });

        return templateElements;
    },

    nodeHasText(el) {
        return el
               && el.childNodes
               && el.childNodes.length
               && el.childNodes[0].nodeValue
               && el.childNodes[0].nodeValue.trim();
    },

    isComponentEditable(el, editableClass) {
        if (!editableClass) {
            return true;
        }

        return el && el.classList.length && el.classList.contains(editableClass);
    },

    // parses over all components inside a tree
    getComponents(parentModel, callback) {
        this.parseComponents(parentModel, (models) => {
            models.forEach(model => {
                callback(model);
            });
        });
    },

    parseComponents(model, callback) {
        const models = [];

        models.push(model);
        const updateAll = model => {
            model.get('components').each(model => {
                models.push(model);
                return updateAll(model);
            });
        }

        updateAll(model);
        callback(models);
    },

    setContainerAttr(model, container, selector) {
        const child = model.find(selector)[0];
        child.setAttributes({
            'data-tc-container': container
        });
    },

    insertContent(grapeEditor, el, content) {
        const model = grapeEditor.DomComponents.getWrapper().find(el)[0];
        model.components(content);
    },

    replaceContent(grapeEditor, el, content) {
        const model = grapeEditor.DomComponents.getWrapper().find(el)[0];
        return model.replaceWith(content);
    },

    select(grapeEditor, el) {
        const $el = $('.gjs-frame').contents().find(el).get(0);
        const select = grapeEditor.getWrapper().getEl().querySelector(el);

        if (!select) {
            return undefined;
        }

        grapeEditor.select(select);
        return grapeEditor.getSelected();
    },

    addBlocks(grapeEditor, blocks) {
        const blockManager = grapeEditor.BlockManager;

        blockManager.getAll().reset();
        blocks.forEach(block => {
            this.addBlock(grapeEditor, block);
        });
    },

    addBlock(grapeEditor, block) {
        const blockManager = grapeEditor.BlockManager;

        blockManager.add(block.id, {
            label: this.buildBlockLabel(block.name, block.preview_image_url, block.description),
            content: block.html,
            attributes: {
                class: 'tc-block tc-block--full',
                'data-block-id': block.id
            },
            type: block.type_name || '',
            type_id: block.type_id
        });
    },

    buildBlockLabel(label, image, description) {
        return `
            <div>
                <label class="control-label">${label}</label>
                <div class="tc-block__img">
                    <img src="${image}" class="img-responsive-full" data-block-description="${description}">
                </div>
            </div>
        `;
    },

    // TODO: @font-face is not added multiple times when needed
    // let parsed = this.grapeEditor.editor.get('Parser').parseCss(this.styles);
    // right test for this one,
    // might need to use native for loops to improve speed, this will also allow use to break out when no match is found
    parseCss(styles) {
        let results = [];

        styles.forEach(item => {
            let newRes = true;

            if (!results.length) {
                results.push(item);
                newRes = false;
            }

            results.forEach((resultItem, index) => {
                if (
                    resultItem.get('selectorsAdd') === item.get('selectorsAdd')
                    && resultItem.get('mediaText') === item.get('mediaText')
                    && resultItem.get('selectors').getFullString() === item.get('selectors').getFullString()
                ) {
                    resultItem.set('style', Object.assign(item.get('style'), resultItem.get('style')));
                    results[index] = resultItem;
                    newRes = false;
                }
            });

            if (newRes) {
                results.push(item);
            }
        });

        return results;
    },

    addPlaceholders(model, container, placeholder) {
        const containerEl = model.getEl().querySelector(container);
        const containerElIsEmpty = !this.elHasContent(containerEl);

        if (containerElIsEmpty) {
            model.find(containerEl)[0].components(placeholder);
        }
    },

    elHasContent(el) {
        if (!el) {
            return false;
        }

        return el.children.length > 0 || el.textContent.trim() !== '';
    },

    getElementIds(el) {
        const results = [];
        const elements = el.querySelectorAll('*');

        for (var i = elements.length - 1; i >= 0; i--) {
            const id = elements[i].getAttribute('id');
            if (id) {
                results.push(id);
            }
        }

        return results;
    },

    inlineIdStyles(el, html, css) {
        const ids = this.getElementIds(el);
        const activeCss = DocumentUtils.filterCssIds(css, ids);
        let inlined = DocumentUtils.inlineBlock(html, activeCss);
        return DocumentUtils.stripElementIdsExcept(inlined);
    },

    imgToBgImg(el) {
        if (el.tagName !== 'IMG') {
            console.log('imgToBgImg el is not an img element');
            return;
        }

        const imgStyles = window.getComputedStyle(el);
        const $el = $(el);
        $el.removeData('gjsType');

        const $bg = $(`<div></div>`)
                    .attr('style', $el.attr('style'))
                    .attr('class', `${$el.attr('class')} te-bg-image`)
                    .css({
                        backgroundImage: `url(${el.src})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: `${imgStyles.width} ${imgStyles.height}`,
                        backgroundPositionX: 'initial',
                        backgroundPositionY: 'initial',
                        top: imgStyles.top,
                        left: imgStyles.left,
                        height: $el.height(),
                        width: $el.width(),
                    });

        if ($el.data().presetIds) {
            $bg.attr('data-preset-ids', JSON.stringify($el.data().presetIds));
        }

        return $bg.get(0);
    },

    getBgDecorations(grapeEditor) {
        return {
            backgroundImage: grapeEditor.StyleManager.getProperty('decorations', 'background-image').attributes.value,
            backgroundPosition: grapeEditor.StyleManager.getProperty('decorations', 'background-position').attributes.value,
            backgroundPositionX: grapeEditor.StyleManager.getProperty('decorations', 'background-position-x').attributes.value,
            backgroundPositionY: grapeEditor.StyleManager.getProperty('decorations', 'background-position-y').attributes.value,
            backgroundSize: grapeEditor.StyleManager.getProperty('decorations', 'background-size').attributes.value,
        };
    },

    setBgFromCoordinates(grapeEditor, image, coordinates) {
        this.setDecoration(grapeEditor, 'background-image', `url(${image})`);
        this.setDecoration(grapeEditor, 'background-position', `${coordinates.left}px ${coordinates.top}px`);
        this.setDecoration(grapeEditor, 'background-position-x', `${coordinates.left}px`);
        this.setDecoration(grapeEditor, 'background-position-y', `${coordinates.top}px`);
        this.setDecoration(grapeEditor, 'background-size', `${coordinates.width}px ${coordinates.height}px`);
    },

    setBgFromPreset(grapeEditor, preset) {
        this.setDecoration(grapeEditor, 'background-image', preset.backgroundImage);
        this.setDecoration(grapeEditor, 'background-position', preset.backgroundPosition)
        this.setDecoration(grapeEditor, 'background-position-x', preset.backgroundPositionX);
        this.setDecoration(grapeEditor, 'background-position-y', preset.backgroundPositionY);
        this.setDecoration(grapeEditor, 'background-size', preset.backgroundSize);
    },

    setDecoration(editor, field, value) {
        editor.StyleManager.getProperty('decorations', field).setValue(value);
    },

    isFoundationTemplate(message) {
        const dom = (new DOMParser()).parseFromString(message, "text/html");
        const container = dom.querySelector('table.body table.container > tbody > tr > td, table.body table.container > tbody > tr > th');
        return !!container;
    }
}